import { fetchFromAPI } from '../../helper/helpers';
import { API } from '../../helper/endpoints';
export default {
  async validate_access_freemiumplan() {
    const response = await fetchFromAPI(API.VALIDATE_FREEMIUM, {
      method: 'GET',
    });

    return response.data;
  },

  async subscribe_freemium(_, payload) {
    const response = await fetchFromAPI(API.SUBSCRIBE_FREEMIUM, {
      body: payload,
    });

    return response;
  },

  async listAllPlans(context) {
    const response = await fetchFromAPI(API.FETCH_PLANS, {
      method: 'GET',
    });

    if (!response.success) {
      context.commit('failedToFetchPlansInfo', {
        failedToFetchPlansInfo: response.error.error_message,
      });
      return response.success;
    }

    context.commit('listSubscriptionPlans', {
      listSubscriptionPlans: response.data.products,
    });

    return response.success;
  },

  async userBasedPlanDetails(context, payload) {
    const response = await fetchFromAPI(API.USER_TYPE_BASED_PLAN, {
      body: payload,
    });

    if (!response.success) {
      context.commit('failedToFetchProductListMessage', {
        failedToFetchProductListMessage: response.error,
      });

      return response.success;
    }

    context.commit('listUserBasedPlan', {
      userBasedPlanInfo: response.data.product_info[0],
    });

    return response.success;
  },

  async createSubscription(context, payload) {
    const response = await fetchFromAPI(API.CREATE_SUBSCRIPTION, {
      body: payload,
    });
    if (!response.success) {
      context.commit('subscriptionErrorMessage', {
        subscriptionErrorMessage: response.error.error_message,
      });
      return false;
    }

    context.commit('subscriptionSuccessData', {
      subscriptionSuccessData: response.data,
    });
    return response.success;
  },

  async cancelSubscription(context, payload) {
    let id = payload.subscriptionId;
    const response = await fetchFromAPI(
      `${API.CANCEL_SUBSCRIPTION}/${id}`,
      {
        method: 'PATCH',
      },
    );

    if (!response.success) {
      context.commit('failedToDeleteSubscription', {
        failedToDeleteSubscription: response.error.error_message,
      });
      return response.success;
    }
    context.commit('subscriptionDeleted', {
      subscriptionDeleted: response.data.subscriptionDeletionStatus,
    });
    return response.success;
  },

  async listsubscription(context) {
    const response = await fetchFromAPI(API.LIST_SUBSCRIPTION, {
      method: 'GET',
    });

    if (!response.success) {
      context.commit('failedToListActiveSubscription', {
        failedToListActiveSubscription: response.error.error_message,
      });
      return response.success;
    }

    localStorage.setItem('plan', !!response.data.subscription.data.length);

    context.commit('subscriptionList', {
      subscriptionList: response.data.subscription,
      whitelisted: response.data.whitelisted || false
    });

    return response.success;
  },

  async fetchSavedCard(context) {
    const response = await fetchFromAPI(API.FETCH_SAVED_CARD, {
      method: 'GET',
    });

    if (!response.success) {
      context.commit('failedToFetchCardList', {
        failedToFetchCardList: response.error.error_message,
      });
      return response.success;
    }
    context.commit('cardLists', {
      cardLists: response.data.cardLists.data,
    });
    return response.success;
  },

  async fetchHistory(context) {
    const response = await fetchFromAPI(API.TRANSACTION_HISTORY, {
      method: 'GET',
    });

    if (!response.success) {
      context.commit('failedToListInvoice', {
        failedToListInvoice: response.error.error_message,
      });
      return response.success;
    }

    context.commit('invoiceList', {
      invoiceList: response.data.invoiceList,
    });
    return response.success;
  },

  async deleteCard(context, payload) {
    let id = payload.cardId;
    const response = await fetchFromAPI(`${API.DELETE_CARD}/${id}`, {
      method: 'PATCH',
    });
    if (!response.success) {
      context.commit('failedToDelete', {
        failedToDelete: response.error.error_message,
      });
      return response.success;
    }
    return response.success;
  },
};
